export const discChooseData = {
    title: "Hoe kies je een disk?",
    rows: [
        {
            title: "Hoe kies je een menstruatiedisk?",
            content: `
<p>Menstruatiedisks komen in verschillende breedtes, hardheden en modellen. Er is niet één "one size fits all"-disk, helaas. 
Een disk die voor een ander goed werkt, hoeft niet bij jou goed te werken.</p>
<p>Speciaal om dit proces makkelijk te maken hebben we de <a href="/diskquiz">diskquiz</a> gemaakt.</p>`
        },
        {
            title: "Waarop moet je letten bij het kiezen van een disk?",
            content: `
                 <ul>
                    <li>Breedte van de disk: wordt bepaald door je baarmoedermondhoogte.</li>
                    <li>Hardheid van de disk: ligt aan hoe gevoelig je vagina en blaas zijn.</li>
                    <li>Vorm van de disk: persoonlijke voorkeur.</li>
                    <li>Makkelijk eruit halen: persoonlijke voorkeur. Wil je een steeltje of extra lusje? </li>
                    <li>Wegwerp op herbruikbaar: persoonlijke voorkeur.</li>
                    <li>Makkelijk te verkrijgen: helaas zijn de meeste disks nog niet zo makkelijk in NL te verkrijgen.</li>
                    <li>Inhoud van de disk: verschilt per disk.</li>
                </ul>

<p>Speciaal om dit proces makkelijk te maken hebben we de <a href="/diskquiz">diskquiz</a> gemaakt.</p>`
        }
    ]
}